import { itiHttpService } from './../../iti-core-vue/services/iti-http-service';
import { itiTokenService, itiPermissionService } from '@/iti-core-vue';
import { store } from '@/iti-core-vue/store';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { timeStamp } from 'console';
import { API } from '@/shared/api';
import EventBusType, { EventBus } from '@/shared/services/event-bus';


@Module({
    namespaced: true,
    name: 'PermissionsModule',
    store,
    dynamic: true,
})
class PermissionsModule extends VuexModule {

    public permissions: string[] = [];

    @Action
    public async getPermissions() {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.get(API.permissions);
         this.context.commit('updatePermissions', res);
    }

    @Mutation
    public updatePermissions(items: string[]){
        this.permissions = items;
        EventBus.$emit(EventBusType.updatePermissions);
    }
}

export default getModule(PermissionsModule);
